import axios from 'axios'
import http from '../services/http'

// Cutover flag. When VUE_APP_USE_API_AUTH==='true' the app authenticates against
// the new Laravel API (/api/login, Sanctum token). Otherwise it keeps using the
// legacy PHP login — so deploying this code does NOT change login until you flip
// the flag and rebuild. Both endpoints return the same {access_token:[t], user_data:[json]}
// shape, so the response handling is shared.
const USE_API_AUTH = process.env.VUE_APP_USE_API_AUTH === 'true'
const LEGACY_LOGIN = 'https://m4a.ramacsystems.com/backend/users/logIn.php'

export default {
    state: {
        token: localStorage.getItem('access_token'),
        userDetails: localStorage.getItem('userDetails')
    },

    mutations: {
        retrieveToken(state, token) {
            state.token = token
        },
        destroyToken(state) {
            state.token = null
        },
        storeUser(state, userDetails) {
            state.userDetails = userDetails
        },
    },

    actions: {
        retrieveToken(context, credentials) {
            const request = USE_API_AUTH
                ? http.post('/api/login', { email: credentials.email, password: credentials.password })
                : axios.get(LEGACY_LOGIN, { params: { email: credentials.email, password: credentials.password } })

            return request
                .then(response => {
                    context.commit('storeUser', response.data)
                    const token = response.data.access_token[0]
                    const userDetails = JSON.parse(response.data.user_data[0])

                    context.commit('retrieveToken', token)
                    localStorage.setItem('userType', userDetails.userType)
                    localStorage.setItem('fullname', userDetails.fullname)
                    localStorage.setItem('access_token', token)

                    // Legacy mode keeps the client-set 12h expiry. API mode relies on
                    // server-side token expiry + the 401 interceptor (see services/http.js).
                    if (!USE_API_AUTH && userDetails.userType !== 'viewer') {
                        localStorage.setItem('dateTorken', new Date().getTime() + 43200000)
                    }
                    return response
                })
                .catch(error => {
                    const x = document.getElementById('snackbar')
                    if (x) {
                        x.className = 'show'
                        setTimeout(() => { x.className = x.className.replace('show', '') }, 3000)
                    }
                    throw error
                })
        },

        destroyToken(context) {
            // Revoke the token server-side when on the API (best-effort).
            if (USE_API_AUTH && context.state.token) {
                http.post('/api/logout').catch(() => {})
            }
            localStorage.removeItem('access_token')
            localStorage.removeItem('userType')
            localStorage.removeItem('fullname')
            localStorage.removeItem('dateTorken')
            context.commit('destroyToken')
        },
    },

    getters: {
        loggedIn(state) {
            if (USE_API_AUTH) {
                // No viewer bypass on the API path — a valid token is required
                // for everyone (closes SECURITY_AUDIT C4).
                return state.token !== null && state.token !== ''
            }
            // Legacy behaviour preserved until cutover.
            const userType = localStorage.getItem('userType')
            if (userType === 'viewer') return true
            return state.token !== null
        }
    }
}
